var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterBg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 213,
    viewBox: "0 0 380 213",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.982 307.951C156.16 288.691 109.329 269.477 62.51 250.221C54.9817 247.151 51.416 238.575 54.4869 231.017C72.6946 186.356 88.6674 157.491 107.114 110.981C112.603 99.1327 125.938 75.171 153.386 59.5331C200.444 32.7295 249.904 52.6659 258.743 56.2404C285.545 67.011 302.541 84.3369 311.072 94.5278C280.562 169.521 252.636 226.068 222.287 299.864C219.203 307.389 210.512 311.024 202.983 307.952L202.982 307.951Z",
    fill: "url(#paint0_linear_1204_487)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1204_487",
    x1: 256.497,
    y1: 0,
    x2: 120.426,
    y2: 299.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA9A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBg2);
export default __webpack_public_path__ + "static/media/footer-bg-2.51a83bd04ed974e89b26c3bc0128469a.svg";
export { ForwardRef as ReactComponent };